import * as React from 'react'
import { Row, Col, Icon, IconButton, SelectPicker } from 'rsuite'
import { getValueFromOptions } from '../../utils/dataUtil'

export default function ExpertName({
  name,
  email,
  emailMarginLeft,
  group,
  isSelected,
  status,
  date,
  onDelete = () => {},
  deletable,
  reviewType = '1',
  onChangeReviewType = () => {},
  enableEditReviewType,
  showReviewType
}) {

  const options = [
    {
      label: 'กลั่นกรอง',
      value: '1',
    },
    {
      label: 'จัดประชุม',
      value: '2',
    },
  ]

  let ColSize = 24

  if(deletable){
    ColSize = ColSize - 2
  }

  if(enableEditReviewType){
    ColSize = ColSize - 10
  }

  return (
    <>
      <Row>
        <Col
          lg={ColSize}
          md={ColSize}
          sm={ColSize}
          xs={ColSize}
        >
          {name} {isSelected && !deletable && `( ${status} ${date}) (${getValueFromOptions(options, reviewType)})`}
          {showReviewType ? `(${getValueFromOptions(options, reviewType)})` : null}
        </Col>

        {enableEditReviewType && deletable &&
        <Col lg={10} md={10} sm={10} xs={10}>
          <SelectPicker
            data={options}
            value={reviewType}
            style={{ marginTop: '3px', width: '80%' }}
            searchable={false}
            cleanable={false}
            placeholder="เลือก"
            onChange={(value) => {
              onChangeReviewType(value)
            }}
          />
        </Col>}

        {isSelected && deletable && (
          <Col lg={2} md={2} sm={2} xs={2} style={{ marginBottom: -20 }}>
            <IconButton
              // style={{marginLeft: 50}}
              onClick={onDelete}
              icon={<Icon icon="close" />}
            />
          </Col>
        )}

        <Col lg={24} md={24} sm={24} xs={24} style={{ fontSize: '0.9rem', fontStyle: 'italic' }}>
          {group && (
            <div style={{ marginLeft: emailMarginLeft || 0, color: '#797878' }}>
              {group}
            </div>
          )}
          {email ? (
            <div style={{ marginLeft: emailMarginLeft || 0, color: '#797878' }}>
              อีเมล : {email}
            </div>
          ) : (
            <div style={{ marginLeft: emailMarginLeft || 0, color: '#ff9800' }}>
              <Icon icon="exclamation-circle2" size="lg" />
              &nbsp;&nbsp;ไม่มีอีเมล
            </div>
          )}
        </Col>
      </Row>
      {isSelected && <hr />}
    </>
  )
}
